import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";

class ReligionCache {
    public Model: ReligionData;

    constructor(model: ReligionData) {
        this.Model = model;
    }

    public getName(): string {
        let returnValue = "";

        if (this.Model != null) {
            if (sessionStore.userLanguageCode === "fr") {
                returnValue = this.Model.NameFr;
            }
            else if (sessionStore.userLanguageCode === "en") {
                returnValue = this.Model.NameEn;
            }
            else if (sessionStore.userLanguageCode === "es-MX") {
                returnValue = this.Model.NameEs;
            }
        }

        return returnValue;
    }

    public static toComboboxItem(model: ReligionCache): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(model.Model.Code, model.getName(), 0);
    }
}

class ReligionData {
    public Id: number;
    public Code: string;
    public NameFr: string;
    public NameEs: string;
    public NameEn: string;
}

export { ReligionCache, ReligionData };
